<template>
    <div class="appointment-date-jump-modal">
        <b-modal :id="modalId"
                 @hidden="clearSelected"
                 size="sm">
                <template v-slot:modal-header>
                <h5>{{ $i18n.gt('HEADER_APPOINTMENT_DATE_JUMP') }}</h5>
            </template>
            <div class="jump-select">
                <h4>{{ $i18n.gt('FIELD_APPOINTMENT_DATE_JUMP') }}</h4>
                <b-calendar v-model="selectedDate"
                            :hide-header="true"/>
            </div>
            <template v-slot:modal-footer>
                <b-btn @click="hideModal">{{ $i18n.gt('LABEL_CANCEL') }}</b-btn>
                <b-btn @click="validateJump">{{ $i18n.gt('LABEL_APPOINTMENT_DATE_JUMP') }}</b-btn>
            </template>

        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'AppointmentDateJumpModal',
    props: {
        reloadCalendar: Function,
        reloadSelected: Function,
    },
    data () {
        return {
            selectedDate: this.inputDate ? this.inputDate : null
        }
    },
    computed: {
        modalId() {
            return `appointmentDateJumpModal`
        }
    },
    methods: {
        showModal() {
            this.$bvModal.show(this.modalId)
        },
        hideModal() {
            this.$bvModal.hide(this.modalId)
        },
        clearSelected() {
            this.selectedDate = null
        },
        validateJump() {
            if (this.selectedDate) {
                this.jump()
            } else this.$toasted.error('Please fill out all fields to jump to a specific date', { duration: 5000 })
        },
        async jump() {
            this.hideModal()
            this.$emit('jump', this.selectedDate)
            this.reloadCalendar()
            this.reloadSelected()
        }
    }
})
</script>

<style lang="scss">
    #appointmentDateJumpModal {
        .b-calendar .b-calendar-nav .btn {
            color: var(--gray);
            &:hover {
                color: var(--white);
            }
        }
        .btn-outline-primary {
            color: var(--blue);
            &:hover {
                color: var(--white);
            }
        }
        .jump-select {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }
</style>
